module.exports = __webpack_public_path__ + "static/img_life_saving_gift_banner_3_m@2x-344a8b58d3bbd5996bc00d6f2ccf4fd7.png";